var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from '../../styled';
const Container = styled.div `
  > a {
    text-decoration: none;
  }
`;
const Link = styled.a `
  text-decoration: none;
  overflow: hidden;
`;
const DynamicLinkTab = (_a) => {
    var { TabComponent, renderLink, url, target, e2eId } = _a, restProps = __rest(_a, ["TabComponent", "renderLink", "url", "target", "e2eId"]);
    if (renderLink)
        return (React.createElement(Container, null, renderLink(React.createElement(TabComponent, Object.assign({ renderLink: renderLink }, restProps)))));
    if (url)
        return (React.createElement(Link, { "data-e2e-id": e2eId, href: url, target: target },
            React.createElement(TabComponent, Object.assign({}, restProps))));
    return React.createElement(TabComponent, Object.assign({ e2eId: e2eId }, restProps));
};
export default DynamicLinkTab;
//# sourceMappingURL=DynamicLinkTab.js.map